import { render, staticRenderFns } from "./StimmenSection.vue?vue&type=template&id=4dad8ea0&"
import script from "./StimmenSection.vue?vue&type=script&lang=js&"
export * from "./StimmenSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports